import EmptyState from "~/components/shared/EmptyState";

export function BuildAnnotationsEmptyState() {
  return <NoAnnotationsEmptyState heading="No build annotations" />;
}

export function NoAnnotationsEmptyState({ heading = "No annotations" }: { heading?: string }) {
  return (
    <div className="flex w-full flex-1 items-center justify-center">
      <EmptyState
        heading={heading}
        subheading={
          <>
            <span>Add annotations with </span>
            <a
              href="https://buildkite.com/docs/agent/v3/cli-annotate"
              target="_blank"
              rel="noopener noreferrer"
              className="monospace"
            >
              buildkite-agent annotate
            </a>
            <span>.</span>
          </>
        }
      />
    </div>
  );
}

export function FilteredAnnotationsEmptyState() {
  return (
    <div className="flex w-full flex-1 items-center justify-center">
      <EmptyState
        heading="No annotations match this filter"
        subheading="Try removing or changing the filter to see more annotations."
      />
    </div>
  );
}

export function JobAnnotationsEmptyState() {
  return (
    <div className="flex w-full flex-1 items-center justify-center">
      <EmptyState
        heading="No job annotations"
        subheading={
          <>
            <span>Scope annotations to a job with </span>
            <a
              href="https://buildkite.com/docs/pipelines/configure/annotations#create-a-job-scoped-annotation"
              target="_blank"
              rel="noopener noreferrer"
              className="monospace"
            >
              buildkite-agent annotate --scope=job
            </a>
            <span>.</span>
          </>
        }
      />
    </div>
  );
}
